import { CircleCheck } from 'lucide-react'
import { Button } from '@safe-global/views/components/ui/button'
import { Typography } from '@safe-global/views/components/ui/typography'
import HnSignupLayout from '@safe-global/views/features/hypernative/components/HnSignupFlow/HnSignupLayout'
import css from '@safe-global/views/features/hypernative/components/HnSignupFlow/styles.module.css'
import Track from '@/components/common/Track'
import { HYPERNATIVE_EVENTS } from '@/services/analytics'
import HypernativeLogo from '@safe-global/views/features/hypernative/components/HypernativeLogo'

export type HnSignupIntroProps = {
  onGetStarted: () => void
  onClose: () => void
}

const HnSignupIntro = ({ onGetStarted, onClose }: HnSignupIntroProps) => {
  const features = [
    {
      title: 'Automatic blocking',
      description: "Automatically prevents malicious or non-compliant transactions before they're executed",
    },
    {
      title: 'Custom security rules',
      description: 'Create tailored policies using granular parameters to stop unwanted transactions.',
    },
    {
      title: 'Seamless integration',
      description: 'Works natively within your Safe workflow. No extra steps required.',
    },
  ]

  return (
    <HnSignupLayout contentClassName={css.introColumn}>
      <div className={css.contentWrapper}>
        <div className={css.header}>
          <Typography variant="h1" className={css.title}>
            Guardian
          </Typography>
          <div className={css.poweredBy}>
            <Typography variant="paragraph-small" className={css.poweredByText}>
              powered by
            </Typography>
            <HypernativeLogo fill="var(--color-primary-light)" className="w-[66px]" />
          </div>
          <Typography variant="paragraph-small" className={css.subtitle}>
            Enterprise-level protection for teams and organizations.
          </Typography>
        </div>

        <div className={css.features}>
          {features.map((feature, index) => (
            <div key={index} className={css.feature}>
              <CircleCheck className={css.featureIcon} />
              <div>
                <Typography variant="paragraph-small-bold" className={css.featureTitle}>
                  {feature.title}
                </Typography>
                <Typography variant="paragraph-small" className={css.featureDescription}>
                  {feature.description}
                </Typography>
              </div>
            </div>
          ))}
        </div>

        <div className={css.actions}>
          <Track
            // Mixpanel: The event name is automatically determined from the GA_TO_MIXPANEL_MAPPING based on the action
            {...HYPERNATIVE_EVENTS.GUARDIAN_FORM_STARTED}
          >
            <Button onClick={onGetStarted} className="w-full">
              Get started
            </Button>
          </Track>
          <Button variant="ghost" onClick={onClose} className="w-full">
            Close
          </Button>
        </div>
      </div>
    </HnSignupLayout>
  )
}

export default HnSignupIntro
